import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '@environments/environment';

const baseUrl = `${environment.apiUrl}/automatizaciones`;

@Injectable()
export class AutomatizacionesService { 

    constructor(private http: HttpClient) {}

    getAutomatizaciones() {
        return this.http.post<JSON>(`${baseUrl}/Get_Automatizaciones`, {}, { withCredentials: true })
    }
}